export function setupMautic() {
  if (typeof window.MauticSDKLoaded == 'undefined') { 
    window.MauticSDKLoaded = true;
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://mautic.accesto.pl/media/js/mautic-form.js';
    script.onload = function () {
        window.MauticSDK.onLoad(); 
    };
    head.appendChild(script);
    window.MauticDomain = 'https://mautic.accesto.pl';
    window.MauticLang = { submittingMessage: 'Please wait...' };
  }
  var formName = 'input_blognewsletter_source_page';
  if (typeof window.MauticFormCallback == 'undefined') {
    window.MauticFormCallback = {};
  }
  window.MauticFormCallback[formName] = {
    onValidateStart: function () {
        console.log("start")
      document.getElementById(
        'mauticform_input_blognewsletter_source_page'
      ).value = document.location.href;
    }
  };
  document.getElementById('mauticform_input_blognewsletter_source_page').value =
    document.location.href;
  document.getElementById('mauticform_input_blognewsletter_persona2').value =
    window.persona;
}
